import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose'
import AppBar from 'material-ui/AppBar';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import IconButton from 'material-ui/IconButton';
import Dialog, {
  DialogActions,
  DialogContent,
  withMobileDialog,
} from 'material-ui/Dialog';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';
import CloseIcon from 'material-ui-icons/Close';
import { impedanceModelingPropType } from '../propTypes';
import SimulationModelImg from '../SimulationModelImg';
import ResultList from './ResultList';
import ParamsList from './ParamsList';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  image: {
    width: 300,
  },
  content: {
    marginTop: 15
  },
  resultAvatar: {
    backgroundColor: theme.palette.primary.light
  },
  paramsAvatar: {
    backgroundColor: theme.palette.secondary.light
  }

});

export function SimulationModelModal({
  classes,
  fullScreen,
  data,
  lengthUnit,
  open,
  onClose
}) {
  const { simulationModel, selectedImpedance } = data || {};
  const {
    frequency,
    params,
    characteristicImpedance,
    differentialImpedance,
    propagationalDelay
  } = selectedImpedance || {};
  return (
    <Dialog
      fullWidth
      maxWidth='md'
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant="title" color="inherit" className={classes.flex}>
            {simulationModel}
          </Typography>
          <IconButton color="inherit" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent className={classes.content}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <SimulationModelImg simulationModel={simulationModel} className={classes.image} />
            <ResultList
              classes={classes}
              characteristicImpedance={characteristicImpedance}
              differentialImpedance={differentialImpedance}
              propagationalDelay={propagationalDelay}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ParamsList
              classes={classes}
              simulationModel={simulationModel}
              frequency={frequency}
              params={params}
              lengthUnit={lengthUnit}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Close 
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SimulationModelModal.propTypes = {
  classes:    PropTypes.objectOf(PropTypes.string).isRequired,
  data:       impedanceModelingPropType,
  lengthUnit: PropTypes.string.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  open:       PropTypes.bool.isRequired,
  onClose:    PropTypes.func.isRequired,
};

SimulationModelModal.defaultProps = {
  data: {} 
};

export default compose(
  withMobileDialog(),
  withStyles(styles)
)(SimulationModelModal);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/SimulationModelModal/SimulationModelModal.js